import React, { useState } from 'react'
import PatternButtonListControl from '../../components/GeneratorControls/PatternButtonList'
import ActionButtons from '../../components/GeneratorControls/ActionButtons'
import MotifPatternGenerator from '../../components/MotifPatternGenerator'
import QRGenerator from '../../components/GeneratorControls/QRGenerator'
import { useEffect } from 'react'
import { useContextPanels } from '../../contexts/panelsContext'
import { useContextOnboarding } from '../../contexts/onboardingContext'
import { useContextSnackbar } from '../../contexts/snackbarContext'
import { useEnv } from '../../utils/useEnv'
import { UIElement } from '../../types/UIElements'
import { isMobile } from 'react-device-detect'
import MobileDeviceNotification from '../../components/MobileDeviceNotification'
import InteractionMotivator from '../../components/InteractionMotivator'
import { useContextInteractionMotivator } from '../../contexts/interactionMotivatorContext'
import { useContextMotifGenerator } from '../../contexts/motifGeneratorContext'
import FeatureDiscovery from '../../components/MotifPatternGenerator/FreeLayoutGenerator/FeatureDiscovery'
import { MotifGeneratorType } from '../../components/MotifPatternGenerator/types'
import { FeatureDiscoveryElement } from '../../types/FeatureDiscoveryElement'

const MotifGenerator = () => {
  const { isPanelOpen, closeAll, closePanel } = useContextPanels()
  const {
    isFirstGeneratorVisit,
    setIsFirstGeneratorVisit,
    setFeatureDiscoveryElementsOpen,
    featureDiscoveryElementsAlreadyShown,
    setFeatureDiscoveryElementsAlreadyShown,
  } = useContextOnboarding()
  const { hideSnackbar } = useContextSnackbar()
  const { selectedGeneratorType } = useContextMotifGenerator()
  const { isInteractionMotivatorShownWithHideAnimation } = useContextInteractionMotivator()
  const { isKiosk } = useEnv()
  const [isDialogOpen, setIsDialogOpen] = useState<boolean | undefined>()

  useEffect(() => {
    closeAll()
    if (isFirstGeneratorVisit && isMobile && window.innerHeight < 500) {
      setIsDialogOpen(true)
    } else {
      setIsFirstGeneratorVisit(false)
    }

    if (
      selectedGeneratorType !== MotifGeneratorType.FREE &&
      (isKiosk ||
        !featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.HOME) ||
        !featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.PATTERNLIST) ||
        !featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.ACTIONS))
    ) {
      setFeatureDiscoveryElementsOpen([
        FeatureDiscoveryElement.HOME,
        FeatureDiscoveryElement.PATTERNLIST,
        FeatureDiscoveryElement.ACTIONS,
      ])
      setFeatureDiscoveryElementsAlreadyShown([
        FeatureDiscoveryElement.HOME,
        FeatureDiscoveryElement.PATTERNLIST,
        FeatureDiscoveryElement.ACTIONS,
      ])
    }

    return () => {
      if (isPanelOpen(UIElement.ABOUT)) {
        closePanel(UIElement.ABOUT)
      }

      if (isPanelOpen(UIElement.GALLERY)) {
        closePanel(UIElement.GALLERY)
      }

      // reset generator feature discovery state
      setFeatureDiscoveryElementsOpen([])
      if (isKiosk) {
        setFeatureDiscoveryElementsAlreadyShown([])
      }

      // Hide the snackbar and QR code whenever the generator page component is destroyed
      hideSnackbar()
    }
  }, [])

  useEffect(() => {
    if (
      selectedGeneratorType === MotifGeneratorType.FREE &&
      !featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.FREE_LAYOUT)
    ) {
      setFeatureDiscoveryElementsOpen([FeatureDiscoveryElement.FREE_LAYOUT])
      setFeatureDiscoveryElementsAlreadyShown([
        ...featureDiscoveryElementsAlreadyShown,
        FeatureDiscoveryElement.FREE_LAYOUT,
      ])
    }
  }, [selectedGeneratorType])

  useEffect(() => {
    if (isDialogOpen === false) {
      setIsFirstGeneratorVisit(false)
    }
  }, [isDialogOpen])

  return (
    <div className="h-full w-full" style={{ touchAction: isKiosk ? 'none' : 'auto' }}>
      {isDialogOpen ? <MobileDeviceNotification setIsDialogOpen={setIsDialogOpen} /> : null}
      <MotifPatternGenerator />
      <FeatureDiscovery />
      {isInteractionMotivatorShownWithHideAnimation ? <InteractionMotivator /> : null}
      <PatternButtonListControl />
      <ActionButtons />
      {isKiosk && <QRGenerator />}
    </div>
  )
}

export default MotifGenerator
